import { useState, useEffect } from 'react'
import './tab.css'

const TabPure = (props) => {
  const { tabs: tabsProps, tabStatus, language, transl } = props
  const [tabs, setTabs] = useState(tabsProps || [])

  const selectTab = (tabSelected) => {
    setTabs(tabs.map(tab => ({ ...tab, selected: tab.route === tabSelected.route })))
    tabStatus(tabSelected.route)
  }

  useEffect(() => {
    setTabs(tabs.map(tab => ({
      ...tab,
      title: transl(tab.key)
    })))
  }, [language])

  return (
    <div className='digitalVaultView-menu' role='tablist'>
      {
        tabs.map((tab, i) => {
          if (tab.hidden) return <></>
          return (
            <button
              key={tab.route}
              className='digitalVaultView-menuItem'
              role='tab'
              aria-selected={tab.selected}
              onClick={() => {
                selectTab(tab)
              }}
            >
              {tab.title}
            </button>
          )
        })
      }
    </div>
  )
}

export default TabPure